<template>
  <div :class="classnames" @click="handleClick">
    <slot />
  </div>
</template>

<script>
  import { bem } from '@/mixins/bem.js'

  const namespace = 'modal-hitzone'

  export default {
    name: 'ModalHitzone',
    mixins: [ bem ],
    data: function () {
      return {}
    },
    created: function () {
      this.namespace = namespace
    },
    methods: {
      handleClick: function () {
        this.$emit('click')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/components/Modal/ModalHitzone.vue